import { Badge } from '@liza/ui/components/ui/badge';
import { Button } from '@liza/ui/components/ui/button';
import { XIcon } from 'lucide-react';

/** A labelled pill with a remove button — used for selected diagnoses in the lab order form. */
export const Chip = ({
  label,
  onRemove,
  removeAriaLabel,
}: {
  label: string;
  onRemove: () => void;
  removeAriaLabel: string;
}): React.ReactElement => (
  <Badge variant="outline" className="gap-1 pr-1">
    <span>{label}</span>
    <Button
      type="button"
      size="icon-xs"
      variant="ghost"
      onClick={onRemove}
      aria-label={removeAriaLabel}
      className="size-4 rounded-full"
    >
      <XIcon className="size-3" />
    </Button>
  </Badge>
);
